import {useState} from 'react';

function unwrapped(fn) {
  return fn?.isModalWrapper ? fn.wrappedFunction : fn;
}

function modalWrapper(wrappedFunction, wrapper) {
  return Object.assign(wrapper, {isModalWrapper: true, wrappedFunction});
}

export default function (uiState, modalName, selectedModel, ModelClass, errorName) {
  const [modalOpen, setModalOpen] = useState(false);

  const existingOpenFunction = unwrapped(uiState[`open${modalName}`]);
  uiState[`open${modalName}`] = modalWrapper(existingOpenFunction, (model) => {
    if (selectedModel) {
      uiState[selectedModel] = ModelClass ? new ModelClass(model) : model;
    }
    if (errorName) uiState[errorName] = {};
    if (existingOpenFunction) existingOpenFunction.apply(uiState, [model]);
    setModalOpen(true);
  });

  const existingCloseFunction = unwrapped(uiState[`close${modalName}`]);
  uiState[`close${modalName}`] = modalWrapper(existingCloseFunction, () => {
    setModalOpen(false);
    if (existingCloseFunction) existingCloseFunction.apply(uiState);
    if (errorName) uiState[errorName] = {};
  });

  return modalOpen;
}
